import { useQuery } from "@tanstack/react-query";
import { Alert, Button, Skeleton } from "antd";
import { Navigate, Outlet, useLocation } from "react-router";

import { getAuthSession } from "../../api/auth";
import { qk } from "../../api/queryKeys";

/** Restore the server-side session before mounting any tenant business screen. */
export function RequireAuth() {
  const location = useLocation();
  const session = useQuery({ queryKey: qk.authSession, queryFn: getAuthSession, retry: false, staleTime: 15_000 });

  if (session.isPending) return <div style={{ maxWidth: 720, margin: "12vh auto", padding: 24 }}><Skeleton active paragraph={{ rows: 6 }} /></div>;
  if (session.isError) {
    return (
      <div style={{ maxWidth: 520, margin: "12vh auto", padding: 24 }}>
        <Alert
          type="error"
          showIcon
          message="暂时无法连接服务"
          description="请检查网络或服务状态后重试。"
          action={<Button onClick={() => void session.refetch()}>重试</Button>}
        />
      </div>
    );
  }
  if (!session.data) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  return <Outlet />;
}
